/** Repository-owned SVG only. Namespace fragment references for repeated artwork. */
export function scopeSvg(svg: string, prefix: string): string {
  const ids = new Map<string, string>();
  const markup = svg.replace(/\bid="([^"]+)"/g, (_match, id: string) => {
    const scoped = `${prefix}-${ids.size}`;
    ids.set(id, scoped);
    return `id="${scoped}"`;
  });
  return markup
    .replace(/url\(#([^)]+)\)/g, (_match, id: string) => `url(#${ids.get(id) ?? id})`)
    .replace(/\bhref="#([^"]+)"/g, (_match, id: string) => `href="#${ids.get(id) ?? id}"`);
}
